<template>
  <v-container grid-list-md fluid>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="1200px">
        <v-card>
          <v-card-title>
            <span class="headline">Enter Test Result</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-container grid-list-md fluid>
              <v-layout wrap>
                <v-flex xs12>
                  <div>
                    <strong>Patient Name:</strong>
                    {{currentTest.patient_name}}
                  </div>
                  <div>
                    <strong>Test Name:</strong>
                    {{currentTest.test_name}}
                  </div>
                </v-flex>
                <v-flex xs12>
                  <vue-trix v-model="result" />
                </v-flex>

                <v-flex xs12 class="text-xs-right">
                  <v-btn flat @click.native="dialog = false">Close</v-btn>
                  <v-btn class="mx-0" color="primary" @click.native="saveResult">Save</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-dialog v-model="resultView" max-width="900">
      <v-card>
        <v-card-text>
          <div v-html="currentTest.result"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout row wrap>
      <!-- history -->
      <v-flex xs12> 
        <div class="section-title di-flex align-center justify-space-between">
        <div class>Tests</div> 

          <div style="width: 50%;">
            <v-text-field 
              v-debounce:500ms="getTests"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              label="Search"
              hide-details
              single-line
              outline
              class="rounded"
            ></v-text-field>
          </div>
          </div>

        <v-data-table
          :total-items="history.meta.total"
          :pagination.sync="pagination"
          :headers="headers"
          :items="history.data"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.patient_name }}</td>
              <td>{{ props.item.test_name }}</td>
              <td>{{ props.item.doctor_name }}</td>
              <td>{{ props.item.date | moment('YYYY-MM-DD h:mm:ss A') }}</td>
              <td>{{ props.item.fee | currency('AFN') }}</td>
              <td class="text-capitalize" :class="props.item.status">{{ props.item.status }}</td>
              <td>
                <v-tooltip top v-if="props.item.status === 'pending'">
                  <v-icon color="success" @click="confirm(props.item)" slot="activator">mdi-check</v-icon>
                  <span>Confirm</span>
                </v-tooltip>

                <v-tooltip top v-if="props.item.status === 'pending'">
                  <v-icon color="error" @click="reject(props.item)" slot="activator">mdi-close</v-icon>
                  <span>Reject</span>
                </v-tooltip>

                <v-tooltip top v-if="props.item.status === 'paid'">
                  <v-icon @click="openDialog(props.item)" slot="activator">mdi-file-document</v-icon>
                  <span>Enter Result</span>
                </v-tooltip>

                <v-tooltip top v-if="props.item.status === 'done'">
                  <v-icon @click="viewResult(props.item)" slot="activator">mdi-eye-outline</v-icon>
                  <span>View Result</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import VueTrix from "vue-trix";
export default {
  components: {
    VueTrix
  },
  // layout: "single",
  middleware: "laboratory",
  data() {
    return {
      resultView: false,
      dialog: false,
      result: "",
      currentTest: "",
      history: {
        data: [],
        meta: {},
        links: {}
      },
      search:"",
      pagination: {descending: true},
      headers: [
        { text: "Patient Name", value: "patient.name" },
        { text: "Test Name", value: "patient.name" },
        { text: "Doctor Name", value: "patient.name" },
        { text: "Date", value: "date" },
        { text: "Fee", value: "fee" },
        { text: "Status", value: "status" },
        { text: "", value: "status" }
      ]
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getTests();
      }
    }
  },
  methods: {
    viewResult(test) {
      this.resultView = true;
      this.currentTest = test;
    },
    openDialog(test) {
      this.dialog = true;
      this.currentTest = test;
    },
    async saveResult() {
      await this.axios.put(`/api/lab_tests/${this.currentTest.id}/result`, {
        result: this.result
      });
      this.dialog = false;
      this.getTests();
    },
    getTests() {
      // // history
      const { sortBy, descending, page, rowsPerPage } = this.pagination; 
      let query = `/api/lab_tests/history?rows_per_page=${rowsPerPage}&search=${encodeURIComponent(
        this.search
      )}&page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;
      


      this.axios.get(query).then(result => {
          this.history = result.data;
        });
    },

    confirm(test) {
      this.$modal.show({
        mode: "confirm",
        message: `Confirm ${test.test_name} ?`,
        onConfirm: async () => {
          await this.axios.put(`/api/lab_tests/${test.id}/confirm`);
          this.getTests();
        }
      });
    },

    reject(test) {
      this.$modal.show({
        title: "Rejection",
        confirmBtn: {
          color: "error",
          text: "Yes Reject"
        },
        message: `Reject ${test.test_name} ?`,
        onConfirm: async () => {
          await this.axios.put(`/api/lab_tests/${test.id}/reject`);
          this.getTests();
        }
      });
    },

    deleteTest(test) {
      this.$modal.show({
        message: `Are you sure, you want to delete this tests ?`,
        mode: "delete",
        onConfirm: async () => {
          await this.axios.delete(`/api/tests/${test.id}`);
          this.getTests();
        }
      });
    }
  }
};
</script>

<style>
.hover {
  cursor: pointer;
}
</style>